import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Veiculo extends Service {
  constructor() {
    super()
    this._veiculosRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Veiculos`
    )
    this._dataSyncRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/DataSync`
    )
    this._serviceEmpresa = new Empresa()
  }

  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando Veiculos')
      const response = await this._veiculosRef.get()

      let veiculos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          veiculos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(veiculos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByEmpresa(empresa) {
    try {
      this._loading.setLoading(true, 'Buscando Veiculos')

      const response = await this._veiculosRef
        .where("empresas", "array-contains", empresa)
        .get()

      let veiculos = new Array()

      if (!response.empty) {
        for (let doc of response.docs) {
          veiculos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(veiculos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByFabricanteAndAtivo(fabricante, ativo) {
    try {
      this._loading.setLoading(true, 'Buscando Veiculos')
      const response = await this._veiculosRef
        .where('fabricante', '==', fabricante)
        .where('ativo', '==', ativo)
        .get()
      let veiculos = new Array()

      if (!response.empty) {
        for (let doc of response.docs) {
          veiculos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(veiculos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getByNome(nomes) {
    try {
      this._loading.setLoading(true, 'Buscando Veiculos')
      const response = await this._veiculosRef
        .where('descricao', 'in', nomes)
        .get()

      let veiculos = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          veiculos.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }
      return Promise.resolve(veiculos)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async desativaSincronizacaoAntiga() {
    try {
      const response = await this._dataSyncRef.where('ativo', '==', true)
        .where('descricao', '==', 'Veiculos')
        .get()
      if (!response.empty) {
        const [doc] = response.docs
        const sincAntiga = await this._dataSyncRef.doc(doc.id)
        await sincAntiga.update({ ativo: false })
      }
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async criaSincronizacao(fabricante) {
    try {
      const empresas = await this._serviceEmpresa.getByFabricante(fabricante)
      this._loading.setLoading(true, 'Gerando Sincronização')

      await this.desativaSincronizacaoAntiga()
      await this._dataSyncRef.doc().set({
        ativo: true,
        dataCriacao: new Date(),
        descricao: 'Veiculos',
        empresas: empresas.map(empresa => empresa.cnpj)
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(veiculoId, values) {
    try {
      this._loading.setLoading(true, 'Atualizando Dados do Veiculo')
      delete values.id
      const veiculo = await this._veiculosRef.doc(veiculoId)
      veiculo.update({
        ...values
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando Veiculo')
      let doc = await this._veiculosRef.doc()
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
